import StatusInfo from "manager/cmath/status/info"
import Consumer from "manager/cmath/schedule/consumer/consumer"


export function offcanvasReducer(state, action) {
    if(action['set'] === 'info') {
        return(
            <StatusInfo
                {...action}
            ></StatusInfo>
        )
    }
    else if(action['set'] === 'consumer') {
        return(
            <Consumer
                {...action}
            ></Consumer>
        )
    }
}